var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22q-3.424 0-5.712-2.41T4 13.59q0-1.59.7-3.18A17 17 0 0 1 6.45 7.36Q7.5 5.898 8.725 4.615A44 44 0 0 1 11 2.385q.2-.205.463-.295a1.65 1.65 0 0 1 1.075 0q.263.09.462.295a44 44 0 0 1 2.275 2.23Q16.5 5.898 17.55 7.36t1.75 3.051.7 3.18q0 3.59-2.288 6T12 22m.275-3.077q.3-.025.512-.243a.73.73 0 0 0 .213-.526.77.77 0 0 0-.225-.577.71.71 0 0 0-.575-.192q-1.024.076-2.175-.577-1.15-.654-1.45-2.372a.76.76 0 0 0-.262-.462.73.73 0 0 0-.488-.18.72.72 0 0 0-.575.27q-.225.27-.15.628.425 2.334 2 3.334 1.575.999 3.175.897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water_drop.9ef991abc1f752fa017482afb65bc50c.svg";
export { ForwardRef as ReactComponent };